import React, { useRef, useState } from "react";
import { FolderOpen, RefreshCw } from "lucide-react";
import LibraryPicker from "@/components/LibraryPicker";

// Swap the source clip in place (upload or Media Library); cancelling or a rejected file keeps the old clip and every keyframe, plate and setting.
export default function ReplaceSource({ source, accept, testid, label = "Replace footage" }) {
  const input = useRef(null);
  const [lib, setLib] = useState(false);
  const swap = async (files) => {
    if (!files.length) return;
    const old = source.items;
    source.setRaw(() => []);
    await source.add(files);
    source.setRaw((cur) => (cur.length ? cur : old));
  };
  const pick = (e) => { const files = Array.from(e.target.files || []); e.target.value = ""; swap(files); };
  const btn = "h-8 px-3 rounded-lg border border-[#1477d2]/60 text-xs text-white flex items-center gap-1.5 hover:bg-[#0747a1]/30";
  return (
    <div className="flex items-center gap-1.5" data-testid={`${testid}-group`}>
      <span className="text-[10px] text-zinc-500 mr-0.5">{label}:</span>
      <input ref={input} type="file" accept={accept} className="hidden" onChange={pick} data-testid={`${testid}-input`} />
      <button type="button" onClick={() => input.current?.click()} data-testid={testid} className={btn}><RefreshCw className="w-3.5 h-3.5" />Upload</button>
      <button type="button" onClick={() => setLib(true)} data-testid={`${testid}-library`} className={btn}><FolderOpen className="w-3.5 h-3.5" />From Library</button>
      <LibraryPicker open={lib} onOpenChange={setLib} accept={accept} max={1} onPick={(refs) => swap(refs)} />
    </div>
  );
}
